import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const planService = {
  /** 批量创建江西维保计划。 */
  batchCreate: data => axios.post(`${iffApi}/jxxf/wb/plan/batch`, data),
  /** 分页查询维保项目的计划进度汇总。 */
  projectPage: params => axios.get(`${iffApi}/jxxf/wb/plan/project-page`, { params }),
  /** 删除未开始的维保计划。 */
  remove: id => axios.delete(`${iffApi}/jxxf/wb/plan/${id}`),
  /** 查询维保计划详情。 */
  detail: id => axios.get(`${iffApi}/jxxf/wb/plan/${id}`),
  /** 修改未开始的维保计划。 */
  update: (id, data) => axios.put(`${iffApi}/jxxf/wb/plan/${id}`, data),
  /** 分页查询江西维保计划。 */ page: params => axios.get(`${iffApi}/jxxf/wb/plan`, { params }),
  /** 创建单个江西维保计划。 */ create: data => axios.post(`${iffApi}/jxxf/wb/plan`, data),
  /** 查询可选择的江西维保项目。 */ projects: params => axios.get(`${iffApi}/jxxf/wb/project`, { params })
};
